import Vue from 'vue'
import App from './App.vue'
import '@/styles/index.scss'
import './styles/common.css'
import { VIDEO_HOST } from '@/config/index.js'
import './utils/gsapConfig.js'  // 导入 GSAP 配置
Vue.config.productionTip = false
Vue.prototype.$IMAGE_HOST = IMAGE_HOST
Vue.prototype.$VIDEO_HOST = VIDEO_HOST
import store from './store/index.js';
import PlusImage from "@/components/PlusImage.vue";
import Toast from "@/components/Toast.vue";
import animate from '@/directives/animate'

Vue.component('PlusImage', PlusImage)
Vue.component('Toast', Toast)
Vue.directive('animate', animate)

new Vue({
  el: '#app',
  store: store,  //或者直接写store
  render: h => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this; //创建全局事件总线
  }
});